export default __webpack_public_path__ + "static/media/Yacht.7adad6ca.svg";